export default __webpack_public_path__ + "static/media/container1.45c173ca.jpg";